let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kkycx")).then(() => parcelRequire('6ul0c'));